import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import logo from '../../assets/logo.png';
import useProductCategories from '../../hooks/useProductCategories';

const Navbar = () => {
  const { categories, loading } = useProductCategories();
  const [scrolled, setScrolled] = useState(false);

  const [isClicked, setIsClicked] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const toggleMobile = () => setMobileOpen((v) => !v);

  return (
    <>
      <nav className={`navbar${scrolled ? ' scrolled' : ''}`}>
        <div className="navbar__logo">
          <Link to="/">
            <img className="navbar__logo-img" src={logo} alt="Articsystems" />
          </Link>
        </div>

        <div className="navbar__right">
          <nav className="navbar__links">
            <a href="/">Home</a>

            <div 
              className={`navbar__dropdown${isClicked ? ' dropdown-clicked' : ''}`}
              onMouseEnter={() => setIsClicked(false)}
              onClick={() => setIsClicked(true)}
            >
              <a href="/products" className="navbar__products-btn" aria-label="Products menu">
                Products
                <svg className="chev" viewBox="0 0 7 4" fill="none">
                  <path d="M1 .5l2.5 3 2.5-3" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
                </svg>
              </a>

              <div className="navbar__dropdown-menu">
                {loading ? (
                  <div className="loading-inline">
                    <div className="app-loading__spinner" />
                  </div>
                ) : (
                  categories.map((catObj) => {
                    const formatCategory = (name) => {
                      if (name === 'AI/ML' || name === 'IOT') return name;
                      return name.charAt(0) + name.slice(1).toLowerCase();
                    };
                    return (
                      <div key={catObj.label} className="navbar__dropdown-item-wrapper">
                        <Link
                          to={`/products?category=${encodeURIComponent(catObj.label)}`}
                          className="navbar__dropdown-item"
                        >
                          {formatCategory(catObj.label)}
                          {catObj.subcategories?.length > 0 && (
                            <svg className="chevron-right" viewBox="0 0 4 7" fill="none">
                              <path d="M.5 1l3 2.5-3 2.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
                            </svg>
                          )}
                        </Link>
                        {catObj.subcategories?.length > 0 && (
                          <div className="navbar__submenu">
                            {catObj.subcategories.map((sub) => (
                              <Link
                                key={sub.slug}
                                to={`/product/${sub.slug}`}
                                className="navbar__submenu-item"
                              >
                                {sub.title}
                              </Link>
                            ))}
                          </div>
                        )}
                      </div>
                    );
                  })
                )}
              </div>

            </div>

            <Link to="/engineering-services">Engineering Services</Link>
            <a href="/manufacturing">Manufacturing</a>
          </nav>

          <Link to="/contact" className="btn btn-primary">Contact Us</Link>
        </div>

        <button
          className={`navbar__hamburger${mobileOpen ? ' open' : ''}`}
          onClick={toggleMobile}
          aria-label="Toggle navigation"
        >
          <span />
          <span />
          <span />
        </button>
      </nav>

      <div className={`mobile-menu${mobileOpen ? ' open' : ''}`}>
        <a href="/">Home</a>
        <a href="/products">Products</a>
        <Link to="/engineering-services">Engineering Services</Link>
        <a href="/manufacturing">Manufacturing</a>
        <a href="/contact" className="mobile-menu__cta">Contact Us</a>
      </div>
    </>
  );
};

export default Navbar;
